var map = new Map();
export var camelToSnakeCase = function (value) {
    var _a;
    if (map.get(value)) {
        return (_a = map.get(value)) !== null && _a !== void 0 ? _a : '';
    }
    var snakeString = value.replace(/[A-Z]/g, function (letter) { return "_".concat(letter.toLowerCase()); });
    if (snakeString.slice(0, 1) === '_') {
        snakeString = snakeString.slice(1);
    }
    map.set(value, snakeString);
    return snakeString;
};
//# sourceMappingURL=camelToSnakeCase.js.map